const setOnSort = (payload) => ({
  type: 'setOnSort',
  payload,
});

const setSort = (payload) => ({
  type: 'setSort',
  payload,
});
const setListMovie = (payload) => ({
  type: 'setListMovie',
  payload,
});
const setFetchProps = (payload) => ({
  type: 'setFetchProps',
  payload,
});
const setPage = (payload) => ({
  type: 'setPage',
  payload,
});
const setOnFilters = (payload) => ({
  type: 'setOnFilters',
  payload,
});
const setAvailabilities = (payload) => ({
  type: 'setAvailabilities',
  payload,
});
const setReleaseTypes = (payload) => ({
  type: 'setReleaseTypes',
  payload,
});
const setDateForm = (payload) => ({
  type: 'setDateForm',
  payload,
});
const setDateTo = (payload) => ({
  type: 'setDateTo',
  payload,
});
const setGenres = (payload) => ({
  type: 'setGenres',
  payload,
});
const toggleGenre = (payload) => ({
  type: 'toggleGenre',
  payload,
});
const setVoteMin = (payload) => ({
  type: 'setVoteMin',
  payload,
});
const setVoteMax = (payload) => ({
  type: 'setVoteMax',
  payload,
});
const setUserVoteMin = (payload) => ({
  type: 'setUserVoteMin',
  payload,
});
const setUserVoteMax = (payload) => ({
  type: 'setUserVoteMax',
  payload,
});
const setRuntimeMin = (payload) => ({
  type: 'setuntimeMin',
  payload,
});
const setRuntimeMax = (payload) => ({
  type: 'setRuntimeMax',
  payload,
});
export {
  setOnSort,
  setSort,
  setListMovie,
  setFetchProps,
  setPage,
  setOnFilters,
  setAvailabilities,
  setReleaseTypes,
  setDateForm,
  setDateTo,
  setGenres,
  toggleGenre,
  setVoteMin,
  setVoteMax,
  setUserVoteMin,
  setUserVoteMax,
  setRuntimeMin,
  setRuntimeMax,
};
